<template>
    <div class="pro_box">
        <div class="together">
            <div class="tbs_box" v-if="$store.state.detailsbottom==true">
                <div 
                    class="tab_item" 
                    :class="[active.id==item.id?'cactive':'']"
                    @click="tabswitch(item)"
                    v-for="(item,index) of tab" :key="index">
                    {{ item.title }}
                </div>
            </div>
            <div class="content_box" v-if="$store.state.detailsbottom==true">
                <div 
                    class="cases_iten_box" 
                    @click="check(item)"
                    v-for="(item,index) in caselist" :key="index">
                    <img  :src="item.resource" alt="">
                    <div class="font_box">
                        <div class="font_title">
                            {{ item.title }}
                        </div>
                        <div class="font_brief">
                            {{ item.subtitle }}
                        </div>
                    </div>
                </div>
            </div> 
        </div>
      
        <div class="details_box" v-if="$store.state.detailsbottom==false">
            <el-breadcrumb separator=">">
                <el-breadcrumb-item><a @click="off">{{ active.title }}</a></el-breadcrumb-item>
                <el-breadcrumb-item>案例详情</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="det_content" v-html="$store.state.htmlcontent"></div>
        </div>
    </div>
</template>
<script>
export default{
    data(){
        return{
            active:null,
            tab:[
                {id:0,title:'全部案例'},
                {id:1,title:'法院服务案例'},
                {id:2,title:'企业交付案例'},
            ],
            caselist:[],
            htmlcontent:'',
        }
    },
    created(){
        this.active=this.tab[0]
        this.axioslist()
    },
    methods:{
        axioslist(){
            this.$webhttp.get(`v1/web/type?type=${this.active.id}`).then((res)=>{
                if(res.code==200){
                    this.caselist=res.data
                }else{
                    this.$message.error(res.message)
                }
            })
        },
        off(){
            this.$store.commit('detailsbottom',true)
        },
        check(item){
            this.$store.commit('detailsbottom',false)
            this.$webhttp.get(`v1/web/content?id=${item.id}`).then((res)=>{
                if(res.code==200){
                    // this.htmlcontent=res.data
                    this.$store.commit('htmlcontent',res.data)
                }else{
                    this.$message.error(res.message)
                }
            })
        },
        tabswitch(item){
            this.active=item
            this.axioslist()
           
        }
    },
}
</script>
<style lang="less" scoped>
.el-breadcrumb{
    margin-top: 40px;
    margin-bottom: 24px;
}
.pro_box{
    width: 100%;
    padding: 0px 160px;
    box-sizing: border-box;
    display: flex;
    .details_box{
        width: 100%;
        margin-bottom: 280px;
        .det_content{
            box-sizing: border-box;   
            padding:20px 147px;
        }
    }
    .together{
        display: flex;

    }
    .content_box{
        min-height: 750px;
        box-sizing: border-box;
        padding-left:51px;
        padding-top: 40px;
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 16px;
        .cases_iten_box:hover{
            .font_box{
                  border-left: 1px solid  #027DFC;
                border-right: 1px solid  #027DFC;
                border-bottom: 1px solid  #027DFC;
                .font_brief{
                    color: #101010;
                }
            }
        }
        .cases_iten_box{
            box-sizing: border-box;
            margin-left: 24px;
            margin-bottom: 16px;
            position: relative;
            cursor: pointer;
            height: 360px;
            box-sizing: border-box;
            img{
                box-sizing: border-box;

                width: 420px;
                height: 240px;
                box-sizing: border-box;
                vertical-align: bottom;
            }
            .font_box{
                border-left: 1px solid  #D5D5D5;
                border-right: 1px solid  #D5D5D5;
                border-bottom: 1px solid  #D5D5D5;
                padding:0px 10px 15px 10px;
                height: 120px;
                width: 420px;
                box-sizing: border-box;
                .font_title{
                    padding:19px 0px 13px 0px;
                    font-weight: bold;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    box-sizing: border-box;

                }
                .font_brief{
                    box-sizing: border-box;

                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2; /* 限制显示的行数为2 */
                    overflow: hidden;
                    font-weight: 400;
                    font-size: 14px;
                    color: #606060;
                    line-height: 21px;
                }
            }
        }
    }
    .tbs_box{
        height: 100%;
        box-sizing: border-box;
        padding-top: 40px;
        .tab_item:hover{
            background: #027DFC;
            font-weight: 400;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 40px;

        }
        .cactive{
            background: #027DFC !important;
            color: #FFFFFF !important;
        }
        .tab_item{
            border: 1px solid #ECECEC;
            background: #FFFFFF;
            height: 40px;
            width: 200px;
            text-align: center;
            line-height: 40px;
            box-sizing: border-box;
            cursor: pointer;
            font-weight: 400;
            font-size: 14px;
            color: #606060;
            line-height: 40px;
        }
    }
}
</style>